import React, { useState } from 'react'
import { DropdownCard, type ITabItem, Tabs } from 'shared/ui'
import {
  addConversationNoteTemplate,
  addContactNoteTemplate,
  addTagTemplate,
  handoffToHumanTemplate,
  removeTagTemplate,
  sendSMSTemplate,
  stopConversationTemplate,
} from 'entities/TemplateActions/actions.tsx'
import { handoffToHuman } from 'widgets/TemplateActions/handoffToHuman'
import { type IMergeFieldConfig, MergeField } from 'widgets/MergeField'
import { addTag } from 'widgets/TemplateActions/addTag'
import { removeTag } from 'widgets/TemplateActions/removeTag'
import { addContactNote } from 'widgets/TemplateActions/addContactNote'
import { sendSMS } from 'widgets/TemplateActions/sendSMS'
import { addConversationNote } from 'widgets/TemplateActions/addConversationNote'
import type { InstructionsSectionStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/instructionsSectionStore.tsx'
import styles from './styles.module.scss'

type IShortcutMenuTab = 'mergeFields' | 'actions'

const tabs: ITabItem<IShortcutMenuTab>[] = [
  { key: 'mergeFields', name: 'Merge fields' },
  { key: 'actions', name: 'Actions' },
]

type IShortcutMenuProps = {
  onClose: () => void
  mergeFieldConfig: IMergeFieldConfig
  store: InstructionsSectionStore
}

export const ShortcutMenu = ({ onClose, mergeFieldConfig, store }: IShortcutMenuProps) => {
  const [activeTab, setActiveTab] = useState<IShortcutMenuTab>('mergeFields')

  const {
    entities,
    onAddHandoffToHumanAction,
    getHandoffNotifySettings,
    onAddMergeField,
    onAddTagAction,
    onRemoveTagAction,
    onAddStopConversationAction,
    onSendSMSAction,
    onAddContactNoteAction,
    onAddConversationNoteAction,
  } = store

  const handleDropdownCardClick = (cb: () => void) => () => {
    onClose()
    cb()
  }

  return (
    <div className={styles.wrap}>
      <Tabs
        tabs={tabs}
        activeTabKey={activeTab}
        handleSelectTab={(tab) => setActiveTab(tab.key)}
        variant={'default'}
        tabsClassName={styles.tabs}
      />
      {activeTab === 'mergeFields' && (
        <MergeField
          onCloseMenu={onClose}
          isNoAutoFocus
          onAddMergeField={(field) => onAddMergeField(field, '/')}
          {...mergeFieldConfig}
        />
      )}
      {activeTab === 'actions' && (
        <div className={styles.actionList}>
          <DropdownCard
            item={{
              ...addTagTemplate.dropdownItem,
              onClick: handleDropdownCardClick(() => addTag({ onSave: onAddTagAction })),
            }}
          />
          <DropdownCard
            item={{
              ...removeTagTemplate.dropdownItem,
              onClick: handleDropdownCardClick(() => removeTag({ onSave: onRemoveTagAction })),
            }}
          />
          <DropdownCard
            item={{
              ...addContactNoteTemplate.dropdownItem,
              onClick: handleDropdownCardClick(() =>
                addContactNote(
                  {
                    onSave: onAddContactNoteAction,
                  },
                  entities
                )
              ),
            }}
          />
          <DropdownCard
            item={{
              ...addConversationNoteTemplate.dropdownItem,
              onClick: handleDropdownCardClick(() =>
                addConversationNote(
                  {
                    onSave: onAddConversationNoteAction,
                    shouldHideAttachment: true,
                  },
                  entities
                )
              ),
            }}
          />
          <DropdownCard
            item={{
              ...sendSMSTemplate.dropdownItem,
              onClick: handleDropdownCardClick(() =>
                sendSMS(
                  {
                    onSave: onSendSMSAction,
                  },
                  entities
                )
              ),
            }}
          />
          <DropdownCard
            item={{
              ...stopConversationTemplate.dropdownItem,
              onClick: handleDropdownCardClick(onAddStopConversationAction),
            }}
          />
          <DropdownCard
            item={{
              ...handoffToHumanTemplate.dropdownItem,
              onClick: handleDropdownCardClick(() =>
                handoffToHuman({
                  onSave: onAddHandoffToHumanAction,
                  getData: getHandoffNotifySettings,
                })
              ),
            }}
          />
        </div>
      )}
    </div>
  )
}
